import { Component, OnInit, HostListener } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { CommonService } from '@tech-services/common.service';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { SessionService } from '@tech-services/session.service';
import { AppConfig } from '@tech-utils/app-config.service';

@Component({
  selector: 'tech-menumain',
  templateUrl: './menumain.component.html',
  styleUrls: ['./menumain.component.scss'],
  animations: [
    trigger('filterAnimation', [
      transition(':enter', [
        style({ opacity: 0, width: 0 }),
        animate('0.5s', style({ opacity: 1, width: '80px' })),
      ]),
      transition(':leave', [animate('0.5s', style({ opacity: 0, width: 0 }))]),
    ]),
  ],
})
export class MenumainComponent implements OnInit {
  public pages: any;
  public iconColapse: string = 'chevron-right';
  public menuOpen: boolean = false;
  private scrWidth: number;
  public domain: string = AppConfig.settings.domain;
  public customTheme = localStorage.getItem('ThemeImg');

  constructor(
    public commonService: CommonService,
    private sessionService: SessionService,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.pages = [];
    this.pages.push({
      label: 'k000256', //Token: Portfolio Analysis
      icon: 'house',
      url: '/portfolios',
    });
    if (AppConfig.settings.proposalModule) {
      this.pages.push({
        label: 'k000023', // Token: Proposal',
        icon: 'file-invoice-dollar',
        url: '/proposal',
      });
    }
    if (AppConfig.settings.investmentLab) {
      this.pages.push({
        label: 'k003282', // Token: Asset analysis,
        icon: 'chart-mixed',
        url: '/laboratory',
      });
    }
    this.pages.push({
      label: 'k000662', // Token: Options',
      icon: 'grid',
      url: '/settings',
    });
  }
}
